import { useLoadingState } from '@ds-mgnl/marketing';
import type { AssetDimension } from '../services/productApi';
import { getDimensionAssetMap } from '../services/productApi';

interface DimensionAssetMapState {
	dimension: AssetDimension | null;
	isLoading: boolean;
	error: string | null;
}

export function useDimensionAssetMap(
	slug: string | undefined,
): DimensionAssetMapState {
	const { data, pending, rejected } = useLoadingState<AssetDimension | null>(
		() =>
			slug
				? getDimensionAssetMap(slug, true).then(
						(map) => map.dimensions[slug] ?? null,
					)
				: Promise.resolve(null),
		[slug],
	);

	return {
		dimension: data,
		isLoading: pending,
		error: rejected ? 'Failed to load dimension asset map' : null,
	};
}
